export { default } from './ArrowDownLeft'
